function reviewsSlider() {
    const $slider = $(".reviews-slider-pdp ul.product-grid");

    // Check if slider element exists and hasn't been initialized yet
    if ($slider.length && !$slider.hasClass('slick-initialized')) {
        // Wait for all images to load
        const $images = $slider.find('img');
        let imagesLoaded = 0;
        const totalImages = $images.length;

        if (totalImages === 0) {
            // If no images found, initialize immediately
            initializeSlick();
        } else {
            // Wait for all images to load
            $images.each(function () {
                if (this.complete) {
                    imagesLoaded++;
                    checkImagesLoaded();
                } else {
                    $(this).on('load', function () {
                        imagesLoaded++;
                        checkImagesLoaded();
                    });
                }
            });
        }

        function checkImagesLoaded() {
            if (imagesLoaded === totalImages) {
                initializeSlick();
            }
        }

        function initializeSlick() {
            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }

            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                rows: 1,
                dots: true,
                // centerMode: true,
                // centerPadding: "60px",
                prevArrow: $(".reviews-slider-pdp .slider-button-reviews-prev"),
                nextArrow: $(".reviews-slider-pdp .slider-button-reviews-next"),
                appendDots: $(".reviews-slider-pdp .slick-slider-dots"),
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 750,
                        settings: {
                            centerMode: false,
                            centerPadding: "0px",
                            slidesToShow: 1,
                            dots: true,
                        }
                    },
                ]
            });

            setTimeout(() => {
                $slider.slick('setPosition');
            }, 100);
        }
    } else if ($slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
    }
}

setTimeout(() => {
    reviewsSlider();
}, 500);

$(window).on('resize', function () {
    reviewsSlider();
});